<!--
 * @Author: lijiahui
 * @Date: 2021-01-12 15:58:13
 * @LastEditors: xuhuining
 * @Description: 亲子儿歌组件
-->
<template>
  <div class="childSongs">
    <van-list
      v-model="pageParams.loading"
      :finished="pageParams.finished"
      :finished-text="pageParams.bottomText"
      :immediate-check="false"
      error-text="请求失败，点击重新加载"
      :error.sync="pageParams.error"
      @load="getVideoList()"
    >
      <waterfallComponents
        @clickHander="clickHander"
        ref="waterfall"
        class="water-fall"
        @styleEnd="styleEnd"
      >
        <template slot-scope="props">
          <div
            :style="
              props.data.type <= 1
                ? 'height:167px;'
                : props.data.type == 2
                ? 'height:104px;'
                : 'height:167px;'
            "
            class="info-img"
            v-lazy:background-image="props.data.coverUrl"
          >
            <img
              v-if="props.data.type < 3"
              class="play-btn"
              src="@/assets/images/icon/off.png"
              alt=""
            />
          </div>
          <div class="bottom-content">
            <p class="item-title">
              {{ props.data.name }}
            </p>
            <div class="item-tagAndPlaynum" v-if="props.data.tagName">
              <span class="item-tag">{{ props.data.tagName }}</span>
              <p class="item-playnum">
                <img src="@/assets/images/nweHome/playIcon.png" class="icon" />
                <span>{{ fomatterNum(props.data.watchNum) || 0 }}</span>
              </p>
            </div>
          </div>
        </template>
      </waterfallComponents>
      <template #finished>
        <img style="width:9px;" src="@/assets/images/expertsView/pentagram.png" class="icon" />
        我们会加油更新的 么么哒~
        <img style="width:9px;" src="@/assets/images/expertsView/pentagram.png" class="icon" />
      </template>
    </van-list>
  </div>
</template>

<script>
import waterfallComponents from "@/components/contents/waterfallComponents.vue"; //瀑布流
import { fomatterNum, getCookie, Debounce, isUserLogin,globalGoLogin} from "@/assets/js/common.js";
export default {
  name: 'childSongs',
  data () {
    return {
      userInfo: {}, // 用户信息
      pageParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false,
        bottomText: "",
        finished: false,
      },
      videoList: [],
      sensorsFlag: true, // 埋点
    }
  },
  props: ['ABtest', 'isVideoState'],
  mounted () {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.getVideoList()
  },
  components: { waterfallComponents },
  watch: {
    isVideoState (val) {
      // 监听上次切换tab后拿到类名
      if ($('video')[0]) {
        this.videoDetail = [] // 切换时把视频清空
        this.switchName = this.$store.state.pageState // 切换时的类名
        document.getElementsByClassName(this.switchName)[0].style.display = 'block' // 海报展示
      }
    }
  },
  methods: {
    styleEnd() {
      this.pageParams.loading = false;
    },
    // 跳转详情
    clickHander(item) {
      // if (this.isUserLogin()) {
      // globalGoLogin()
      // } else {
      //   this.$router.push({
      //     name:'parentchildsongsdetail',
      //     query:{
      //       id:item.id
      //     }
      //   })
      // }
      this.$router.push({
        name:'parentchildsongsdetail',
        query:{
          id:item.id
        }
      })
    },
    // 获取列表
    getVideoList() {
      this.$http.post("/breedWiki/fairyTales",{},{data:{periodId:'0',tagId:'2'},page: this.pageParams.page,size: this.pageParams.size,},(res)=>{
        if(res.code===200){
          const { data, total } = res.data;
          this.videoList = [...this.videoList, ...data];
          if (this.videoList.length > this.pageParams.size) {
            this.$refs.waterfall.initData("push", data);
          } else {
            this.$refs.waterfall.initData("init", this.videoList);
          }
          this.$nextTick(() => {
            if (this.videoList.length >= total && data) {
              this.pageParams.finished = true;
              this.pageParams.bottomText =
                "我们会加油更新的，么么哒~";
            } else {
              this.pageParams.page += 1;
              this.pageParams.loading = false;
            }
          });
          if(this.sensorsFlag){
            this.sensorsFlag=false
            sensors.track('Parenting_program_PV_UV',{'Column': '亲子儿歌',})
          }
        } else {
          this.$toast("网络异常");
          this.pageParams.loading = false;
          this.pageParams.error = true;
        }
      }, null, 'lucky')
    },
    fomatterNum, getCookie, Debounce,isUserLogin
  }
}
</script>


<style lang="less" scoped>
.childSongs{
  margin-top: 20px;
}
// 瀑布流样式
.info-img {
  position: relative;
  // width: 167px;
  height: 100px;
  border-radius: 4px 4px 0 0;
  // background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .play-btn {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 20px;
    height: 20px;
  }
  .share-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 26px;
    height: 26px;
  }
  .play-status {
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 4px 0px 8px 0px;
    overflow: hidden;

    span {
      padding: 0 4px;
      display: block;
      font-size: 10px;
      font-weight: bold;
      color: #fff;
      line-height: 17px;
      background: rgba(0, 0, 0, 0.4);
    }
    .playing {
      background: linear-gradient(270deg, #f0ba39 0%, #fbcf6f 100%);
    }
  }
}
.bottom-content {
  padding: 0 8px;
  .item-title {
    margin-top: 8px;
    font-size: 13px;
    font-weight: bold;
    color: #333;
    line-height: 20px;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .item-tagAndPlaynum {
    margin-top: 4px;
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item-tag {
      min-width: 30px;
      height: 20px;
      background: #fedbf0;
      border-radius: 10px;
      font-size: 11px;
      color: #ff67c1;
      line-height: 20px;
      text-align: center;
      padding: 0 5px;
    }
    .item-playnum {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 20px;
      font-size: 12px;
      color: #999;
      .icon {
        width: 11px;
        height: 11px;
        margin-right: 3px;
      }
    }
  }
}
</style>
